interface Action {
  type: string;
  payload: any;
}

type FileHeaders = {
  id: string;
  label: string;
  value: string;
  isSelected?: boolean;
  wrongHeader?: boolean;
};
type CustomFieldsCount = {
  accounts: number;
  contacts: number;
};

export const SET_CHAMPION_TRACKING_IMPORTING_CONTACTS_STATUS =
  'SET_CHAMPION_TRACKING_IMPORTING_CONTACTS_STATUS';
export const SET_CHAMPION_TRACKING_IMPORTING_FILE_NAME =
  'SET_CHAMPION_TRACKING_IMPORTING_FILE_NAME';
export const SET_CHAMPION_TRACKING_CONTACT_OWNERS = 'SET_CHAMPION_TRACKING_CONTACT_OWNERS';
export const SET_CHAMPION_TRACKING_CUSTOM_HEADERS = 'SET_CHAMPION_TRACKING_CUSTOM_HEADERS';
export const SET_CHAMPION_TRACKING_CSV_FIELDS_ARRAY = 'SET_CHAMPION_TRACKING_CSV_FIELDS_ARRAY';
export const SET_CHAMPION_TRACKING_DROPDOWN_VALUES = 'SET_CHAMPION_TRACKING_DROPDOWN_VALUES';
export const SET_CHAMPION_TRACKING_MAPPED_FIELDS_COUNT =
  'SET_CHAMPION_TRACKING_MAPPED_FIELDS_COUNT';
export const SET_CHAMPION_TRACKING_UNMAPPED_MAND_FIELDS =
  'SET_CHAMPION_TRACKING_UNMAPPED_MAND_FIELDS';
export const SET_CHAMPION_TRACKING_MANDATORY_FIELDS_MAPPED =
  'SET_CHAMPION_TRACKING_MANDATORY_FIELDS_MAPPED';
export const SET_CHAMPION_TRACKING_FORMATED_DATA = 'SET_CHAMPION_TRACKING_FORMATED_DATA';
export const SET_CHAMPION_TRACKING_CUSTOM_FIELDS_COUNT =
  'SET_CHAMPION_TRACKING_CUSTOM_FIELDS_COUNT';
export const SET_CHAMPION_TRACKING_IMPORT_COMPLETED_STEPS =
  'SET_CHAMPION_TRACKING_IMPORT_COMPLETED_STEPS';
export const SET_CHAMPION_TRACKING_IMPORTING_CONTACTS_COUNT =
  'SET_CHAMPION_TRACKING_IMPORTING_CONTACTS_COUNT';

export const SET_SELECTED_PREFERENCE = 'SET_SELECTED_PREFERENCE';
export const SET_ACTIVE_CHAMPIONS_TAB = 'SET_ACTIVE_CHAMPIONS_TAB';
export const SET_JOB_CHANGE_COUNT = 'SET_JOB_CHANGE_COUNT';

export const setCTImportingFileName = (fileName: string) => ({
  type: SET_CHAMPION_TRACKING_IMPORTING_FILE_NAME,
  payload: fileName,
});

export const setCTContactOwners = (owners: any) => ({
  type: SET_CHAMPION_TRACKING_CONTACT_OWNERS,
  payload: owners,
});

export const setCTCustomHeaders = (headers: any) => ({
  type: SET_CHAMPION_TRACKING_CUSTOM_HEADERS,
  payload: headers,
});

export const setCTCsvFieldsArray = (csvFields: FileHeaders[]) => ({
  type: SET_CHAMPION_TRACKING_CSV_FIELDS_ARRAY,
  payload: csvFields,
});

export const setCTDropdownValues = (value: FileHeaders[]) => ({
  type: SET_CHAMPION_TRACKING_DROPDOWN_VALUES,
  payload: value,
});

export const setCTMappedFieldsCount = (value: number) => ({
  type: SET_CHAMPION_TRACKING_MAPPED_FIELDS_COUNT,
  payload: value,
});

export const setCTUnMappedMandFields = (value: any) => ({
  type: SET_CHAMPION_TRACKING_UNMAPPED_MAND_FIELDS,
  payload: value,
});

export const setCTMandatoryFieldsMapped = (value: boolean) => ({
  type: SET_CHAMPION_TRACKING_MANDATORY_FIELDS_MAPPED,
  payload: value,
});

export const setCTFormatedData = (value: string) => ({
  type: SET_CHAMPION_TRACKING_FORMATED_DATA,
  payload: value,
});

export const setCTCustomFieldsCount = (value: CustomFieldsCount) => ({
  type: SET_CHAMPION_TRACKING_CUSTOM_FIELDS_COUNT,
  payload: value,
});

export const setCTImportCompletedSteps = (value: { [k: number]: boolean }) => ({
  type: SET_CHAMPION_TRACKING_IMPORT_COMPLETED_STEPS,
  payload: value,
});

export const setCTImportingContactsCount = (value: number) => ({
  type: SET_CHAMPION_TRACKING_IMPORTING_CONTACTS_COUNT,
  payload: value,
});

export const setSelectedPreference = (value: string) => ({
  type: SET_SELECTED_PREFERENCE,
  payload: value,
});

export const setActiveChampionsTab = (value: string) => ({
  type: SET_ACTIVE_CHAMPIONS_TAB,
  payload: value,
});
export const setCTJobChangeCount = (value: number) => ({
  type: SET_JOB_CHANGE_COUNT,
  payload: value,
});

const initialState = {
  importingFileName: '',
  contactOwners: [],
  customHeaders: [],
  csvFieldsArray: [],
  dropdownValues: [],
  mappedFieldsCount: 0,
  unMappedMandFields: [],
  isMandatoryFieldsMapped: false,
  formattedData: '',
  customFieldsCount: {
    accounts: 0,
    contacts: 0,
  },
  importCompletedSteps: { 0: false },
  importingContactsCount: 0,
  selectedPreference: 'Skip',
  activeChampionsTab: 'allChampions',
  ctJobChangeCount: 0,
};

const setChampionTrackingImportReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_CHAMPION_TRACKING_IMPORTING_FILE_NAME:
      return { ...state, importingFileName: action.payload };
    case SET_CHAMPION_TRACKING_CONTACT_OWNERS:
      return { ...state, contactOwners: action.payload };
    case SET_CHAMPION_TRACKING_CUSTOM_HEADERS:
      return { ...state, customHeaders: action.payload };
    case SET_CHAMPION_TRACKING_CSV_FIELDS_ARRAY:
      return { ...state, csvFieldsArray: action.payload };
    case SET_CHAMPION_TRACKING_DROPDOWN_VALUES:
      return { ...state, dropdownValues: action.payload };
    case SET_CHAMPION_TRACKING_MAPPED_FIELDS_COUNT:
      return { ...state, mappedFieldsCount: action.payload };
    case SET_CHAMPION_TRACKING_UNMAPPED_MAND_FIELDS:
      return { ...state, unMappedMandFields: action.payload };
    case SET_CHAMPION_TRACKING_MANDATORY_FIELDS_MAPPED:
      return { ...state, isMandatoryFieldsMapped: action.payload };
    case SET_CHAMPION_TRACKING_IMPORT_COMPLETED_STEPS:
      return { ...state, importCompletedSteps: action.payload };
    case SET_CHAMPION_TRACKING_FORMATED_DATA:
      return { ...state, formattedData: action.payload };
    case SET_CHAMPION_TRACKING_CUSTOM_FIELDS_COUNT:
      return { ...state, customFieldsCount: action.payload };
    case SET_CHAMPION_TRACKING_IMPORTING_CONTACTS_COUNT:
      return { ...state, importingContactsCount: action.payload };
    case SET_SELECTED_PREFERENCE:
      return { ...state, selectedPreference: action.payload };
    case SET_ACTIVE_CHAMPIONS_TAB:
      return { ...state, activeChampionsTab: action.payload };
    case SET_JOB_CHANGE_COUNT:
      return { ...state, ctJobChangeCount: action.payload };
    default:
      return state;
  }
};

export default setChampionTrackingImportReducer;
